import * as React from "react"
import { createRoot } from "react-dom/client"

import OldUIContext from "../../olduicontext"
import LateralNavigation from "./components/LateralNavigation"
import { IItemNavigation } from "./index"

interface OldUIInit {
    makeLateralNavigation: (
        element: HTMLElement | undefined | null,
        prev?: IItemNavigation,
        next?: IItemNavigation,
    ) => void
}

function init(): OldUIInit {
    const makeLateralNavigation = (
        element: HTMLElement | undefined | null,
        prev?: IItemNavigation,
        next?: IItemNavigation,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        const root = createRoot(element)
        root.render(
            <OldUIContext.Consumer>
                {(): JSX.Element => (
                    <LateralNavigation prev={prev} next={next} />
                )}
            </OldUIContext.Consumer>,
        )
    }

    return {
        makeLateralNavigation,
    }
}

export default init
